function isComponentCriticalUserExperiencePath(componentName) {
  const pagePattern = /^Page/;
  const gatePattern = /^Gate/;

  const name = componentName ?? '';
  const isCriticalUserExperiencePath =
    name.match(pagePattern) || name.match(gatePattern);

  return isCriticalUserExperiencePath;
}

export default isComponentCriticalUserExperiencePath;
